import React, { PureComponent } from 'react';
import { number, arrayOf, shape, string, array } from 'prop-types';
import { VictoryTooltip } from 'victory';
import { CustomFlyout } from '../CustomFlyout';

/**
 *
 *
 * @export
 * @class CustomLabel
 * @extends {PureComponent}
 */
export class CustomLabel extends PureComponent {
  static displayName = 'CustomLabel';

  static defaultEvents = VictoryTooltip.defaultEvents;

  static propTypes = {
    contracted: arrayOf(shape({ name: string, label: string, value: number }))
      .isRequired,
    surplus: arrayOf(shape({ name: string, label: string, value: number }))
      .isRequired,
    deficit: arrayOf(shape({ name: string, label: string, value: number }))
      .isRequired,
    rawRevenueData: array,
    chartWidth: number,
    tooltipWidth: number,
    x: number,
  };

  static defaultProps = {
    rawRevenueData: [],
  };

  render() {
    const {
      tooltipWidth,
      x,
      contracted,
      deficit,
      surplus,
      rawRevenueData,
    } = this.props;

    return (
      <VictoryTooltip
        {...this.props}
        flyoutComponent={
          <CustomFlyout
            contracted={contracted}
            deficit={deficit}
            surplus={surplus}
            rawRevenueData={rawRevenueData}
            orientation={this.getOrientation()}
            tooltipWidth={tooltipWidth}
            x={x}
          />
        }
        labelComponent={<div />}
      />
    );
  }

  /**
   *
   * Gets the direction the tooltip should point to
   * @function getOrientation
   * @memberof CustomLabel
   * @returns {string} - 'left' or 'right'
   * @public
   */
  getOrientation = () => {
    const { tooltipWidth, chartWidth, x } = this.props;
    const leftPoint = x - Number(tooltipWidth);
    const rightPoint = x + Number(tooltipWidth);

    let orientation = 'right';
    if (leftPoint < 0 && chartWidth > rightPoint) {
      orientation = 'right';
    } else if (rightPoint > chartWidth && leftPoint > 0) {
      orientation = 'left';
    }
    return orientation;
  };
}



// WEBPACK FOOTER //
// ./src/common/components/BarChart/components/CustomLabel/index.js